import moment from "moment";

const dateTimeFormat = "YYYY/MM/DD HH:mm:ss"; //the format you want to display the date in
const inputFormat = "YYYYMMDDTHHmmssZZ";
const asmtInputFormat = "YYYYMMDDTHHmmss";
//                   20180930T234349643+0000
export const convertDate = (input) => {
  return moment.utc(input, inputFormat).local().format(dateTimeFormat);
};

export const convertAsmtDateToFormat = (input, format) => {
  return moment.utc(input, asmtInputFormat).local().format(format);
};

export const convertMeetingDate = (input) => {
  let utcData = Date.UTC(
    input.substring(0, 4),
    input.substring(5, 7) - 1, //subtracting one from Month becasue java dat uses different index
    input.substring(8, 10),
    input.substring(11, 13),
    input.substring(14, 16),
    input.substring(17, 19)
  );
  return moment(utcData).local().format(dateTimeFormat);
};

export const printDoc = (data, filename) => {
  let binaryArray = [];
  binaryArray.push(data);
  let blob = new Blob(binaryArray, { type: "application/pdf" });
  let a = document.createElement("a");
  let navigator = window.navigator; //used to determine what kind of browser is being used

  if (
    navigator.userAgent.indexOf("Chrome") !== -1 ||
    navigator.userAgent.indexOf("Opera") !== -1
  ) {
    console.log("Printing on chrome/opera");
    document.body.appendChild(a);
    a.style.display = "none";
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    // Saw the commented line below in a stackoverflow post,
    // But it breaks downloading on Chrome/Desktop
    // (https://stackoverflow.com/questions/39375076/how-to-display-pdf-blob-on-ios-sent-from-my-angularjs-app)
    //window.open(URL.createObjectURL(blob,{oneTimeOnly:true}));
  } else if (navigator.userAgent.indexOf("iPad") !== -1) {
    console.log("Printing on ipad");
    let fileURL = URL.createObjectURL(blob);
    a.download = filename;
    a.href = fileURL;
    a.click();
  } else if (
    navigator.userAgent.indexOf("Firefox") !== -1 ||
    navigator.userAgent.indexOf("Safari") !== -1
  ) {
    console.log("Printing on firefox/safari");
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 1000);
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/index.js
// module id = 468
// module chunks = 217